export default __webpack_public_path__ + "static/media/Q7-2.eca2a7d4.jpg";